import axios from '../client';
import { Auth } from 'aws-amplify';
import { showMessage } from "../utils";
import { getProfile } from './utils';


const initialSignUpForm = {
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: '',
    recaptcha: '',
    rules: {
        recaptcha: [{
            required: true,
            message: 'Please verify the captcha',
            trigger: ['change', 'blur']
        }]
    },
}

const initialLoginForm = {
    email: '',
    password: '',
}

const getControls = async (tokens, roomName) => {
    const response = await axios.get('/api/facilitator/'+ roomName + '/controls/')
    const isChecked = response.data.controls.includes('SELECT_ALL')
    const controls = {
        NEED_HELP: isChecked,
        LAST_N: isChecked,
        CREATE_BREAKOUTS: isChecked,
        BREAKOUTS_VISIBILITY: isChecked,
        TIMER: isChecked,
        WHITEBOARD: isChecked,
        FORCE_TO_LOBBY: isChecked,
        CREATE_POLL: isChecked,
        BROADCAST_MESSAGE: isChecked,
        ADD_PASSWORD_LOCK: isChecked,
        SELECT_ALL: isChecked,
        SEE_PARTICIPANTS_NAMES:isChecked,
        CAN_RECORD_VIDEO: false,
        facilitationControls: isChecked,
        HANDS_LIST: true // Raise hand should always present in the list
    };
    const facilitationControls = ['TIMER','WHITEBOARD','FORCE_TO_LOBBY', 'NEED_HELP', 
        'CREATE_POLL', 'BROADCAST_MESSAGE', 'HANDS_LIST', 'CAN_RECORD_VIDEO'];

    response.data.controls.forEach(control => {
        controls[control] = true;
        if(!controls['facilitationControls']){
            controls['facilitationControls'] = facilitationControls.includes(control);
        }
    });
    return controls;
}


const state = () => ({
    signUpForm: Object.assign({}, initialSignUpForm),
    loginForm: Object.assign({}, initialLoginForm),
    profile: getProfile(),
    tokens: JSON.parse(localStorage.getItem('user')) || null,
    controls: {},
    authLoading: false,
    sendEmailLoading: false,
    changePassword: false
})

const actions = {
    async getControls({ commit }, roomName) {
        try{
            const tokens =  JSON.parse(localStorage.getItem('user')) || null;
            const controls = await getControls(tokens,roomName);
            commit('updateControls', controls)
        }  catch (err) {
            if (err.response.data.message === "TOKEN_EXPIRED") {
                try {
                    const cognitoUser = await Auth.currentAuthenticatedUser();
                    const currentSession = await Auth.currentSession();
                    cognitoUser.refreshSession(currentSession.refreshToken, async (err, session) => {
                        if(!err) {
                            const { idToken, refreshToken, accessToken } = session;
                            const tokens = {idToken: idToken.jwtToken, accessToken: accessToken.jwtToken, refreshToken: refreshToken.token }
                            localStorage.setItem("user", JSON.stringify(tokens));
                            commit('setTokens', tokens);
                            const controls = await getControls(tokens, roomName);
                            commit('updateControls', controls)
                        } else {
                            localStorage.removeItem("user");
                            commit('setTokens', null);
                        }
                    })
                } catch (err) {
                    localStorage.removeItem("user");
                    commit('setTokens', null);
                }
            } else {
                commit('updateControls', {});
            }
        }
    },

    async refreshTokens({commit}, callback) {
        try {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            const currentSession = await Auth.currentSession();
            cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
                if(!err) {
                    const { idToken, refreshToken, accessToken } = session;
                    const tokens = {idToken: idToken.jwtToken, accessToken: accessToken.jwtToken, refreshToken: refreshToken.token }
                    localStorage.setItem("user", JSON.stringify(tokens));
                    commit('setTokens', tokens)
                    if(callback) {
                        callback();
                    }
                } else {
                    localStorage.removeItem("user");
                    commit('setTokens', null);
                }
            })
        } catch (err) {
            localStorage.removeItem("user");
            commit('setTokens', null);
        }
    },
    // eslint-disable-next-line no-unused-vars
    async changePassword ({ commit }, data) {
        const cognitoUser = await Auth.currentAuthenticatedUser();

        cognitoUser.changePassword(data.oldPassword, data.newPassword, function(err) {
            if (err && err.message === "InvalidParameterException") {
                showMessage('Password doesn’t meet minimum requirements', 'error')
                return;
            }
            if(!err){
                showMessage('Password changed successfully', 'success')
            } else {
                showMessage('Something went wrong. Please try again later', 'error')
            }
        });
    }
}

const mutations = {
    onCaptchaVerified(state, recaptchaToken, formRef) {
        state.signUpForm.recaptcha = recaptchaToken;
        formRef.validateField('recaptcha');
    },

    onCaptchaExpired(state, formRef) {
        state.signUpForm.recaptcha = '';
        formRef.recaptcha.reset();
    },

    resetUserDataForm(state) {
        state.signUpForm = Object.assign({}, initialSignUpForm);
        state.loginForm = Object.assign({}, initialLoginForm);
    },

    updateLoginStatus(state, status) {
        state.profile.loggedIn = status;
    },

    updateProfile(state, profile) {
        state.profile = profile;
    },

    updateAdminProfile(state, profile) {
        state.adminProfile = profile;
    },

    updateControls(state, controls) {
        state.controls = controls;
    },

    setTokens(state, tokens) {
        state.tokens = tokens
        state.profile = getProfile()
    },

    setAuthLoading(state, status){
        state.authLoading = status
    },

    setSendEmailLoading(state, status){
        state.sendEmailLoading = status
    },

    setChangePassword(state, status){
        state.changePassword = status
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
